import {
    ref,
    watch
} from 'vue';
// import axios from 'axios';
import {
    Howl,
    Howler
} from 'howler'



const flvJs = require('flv.js')


export default function usePlayer() {

    // 播放器播放状态 0未播放 1暂停 2播放中
    const playerStatus = ref(0)

    const playingArticleId = ref('')

    const flvPlayer = ref(null)
    const vjsInstance = ref(null)
    let flvInstance;

    const howlerList = ref([])
    const howlerCanplay = ref(false)
    const curParagraphIndex = ref(0)

    const readerAudioSrcArr = ref([]) // 当前文章音频地址列表
    const readerCurAudioSrc = ref('') // 当前文章音频地址
    const readerTextArr = ref([]) // 当前文章段落列表
    const readerCurParagraph = ref('') // 当前文章段落

    // 播放器初始化 重置音频列表 获取新的文章内容并播放
    const playerInit = async (flycard) => {


        if(!flycard) return
        // console.log(flycard);
        
        let type = flycard ? diffContentType(flycard):'audio'


        videoStop()
        Howler.stop()
        howlerList.value = []
        howlerCanplay.value = false
        curParagraphIndex.value = 0

        if (type === 'audio') {

            let content = flycard.content
            handleReaderData(content)
        } else if (type === 'video') {

            let timer = setInterval(() => {
                if(document.querySelector('.cards-swiper-container .swiper-slide-active .card-active-0')) {

                   
                    initFlv(document.querySelector('.cards-swiper-container .swiper-slide-active .card-active-0 video'), flycard)
                    clearInterval(timer)
                }
                
            }, 20);



        }


    }

    // 停止flv video播放
    const videoStop = () => {
        if (flvInstance) {
            flvInstance.pause()
        }
    }

    // 初始化flv 
    const initFlv = (dom, source) => {
        flvInstance = flvJs.createPlayer({
            type: 'mp4',
            hasAudio: false,
            isLive: true,
            url: source.videourl,
            poster: source.imgs[0],
        }, {
            enableWorker: false,
            enableStashBuffer: false,
        })
        flvInstance.attachMediaElement(dom)
        dom.addEventListener('play', function() {
            playerStatus.value = 2
        })
        dom.addEventListener('pause', function() {
            playerStatus.value = 1
        })
        flvInstance.load()
        flvInstance.play()
    }


    // 当前飞卡是否为视频
    const diffContentType = (content) => {
        return content.type === '6' ? 'video' : 'audio'
    }

    // 切换播放器状态
    const togglePlayerStatus = (flycard, oldStatus) => {
        let articleId = flycard.articleId
        let type = diffContentType(flycard)
        if (playingArticleId.value != articleId) {
            // 播放的文章id改变了
            // 停止旧播放 开始新播放
            playingArticleId.value = articleId;
            playerStatus.value = 2;
            playerInit(flycard)
            if (type === 'audio') {

                recycleFetchAudio()
            } else if (type === 'video') {
                console.log('!!!', flvInstance);
                flvInstance.play();
            }

        } else {
            // 播放的文章id没变
            // 暂停或者续播

            switch (oldStatus) {
                case 0:
                    // 续播
                    playerStatus.value = 2;
                    type === 'audio' ? howlerList.value[curParagraphIndex.value].play() : flvInstance.play();
                    break;
                case 1:
                    // 续播
                    playerStatus.value = 2;
                    type === 'audio' ? howlerList.value[curParagraphIndex.value].play() : flvInstance.play();
                    break;
                case 2:
                    // 暂停
                    playerStatus.value = 1;
                    console.log('here type', type);
                    type === 'audio' ? howlerList.value[curParagraphIndex.value].pause() : flvInstance.pause();
                    break;
                case 3:
                    // 打开其他页面
                    playerStatus.value = 0;
                    playingArticleId.value = '';
                    Howler.stop()
                    break;

                default:
                    break;
            }




        }


    }

    // 处理文章数据
    const handleReaderData = (htmlStr) => {

        let oDiv = document.createElement("div");
        oDiv.innerHTML = htmlStr.replace(/poster=\"|src=\"/g, 'data-src="');

        let textArr = [];


        for (let i in oDiv.childNodes) {
            if (!!oDiv.childNodes[i].innerText) {
                textArr.push(oDiv.childNodes[i].innerText);
            }
        }

        if (textArr.length === 1 && textArr[0].length > 15) {
            textArr = textArr[0].split('。')
        }


        textArr = [...new Set(textArr)]
        readerTextArr.value = [...textArr]
        readerCurParagraph.value = textArr[0]
        readerCurAudioSrc.value = formTTS(readerCurParagraph.value)
        readerAudioSrcArr.value = []
        readerTextArr.value.forEach(text => {
            readerAudioSrcArr.value.push(formTTS(text))
        })


    }

    // 生成播放音频地址
    const formTTS = (e) => {
        let params = {
                tex: encodeURI(e),
                cuid: "sznews",
                cod: 2,
                lan: "zh",
                ctp: 1,
                pdt: 301,
                spd: 5,
                per: 0,
                vol: 5,
                pit: 5,


            },
            paramsArr = []

        for (let key in params) paramsArr.push(key + '=' + params[key])
        return "https://tts.baidu.com/text2audio?" + paramsArr.join("&")
    }


    // 通过音频地址获取到blob地址用于howler播放
    const fetchAudio = async (src) => {
        let res = await fetch(src, {
            method: 'GET',
        })
        let blob = await res.blob()
        let url = window.URL.createObjectURL(blob)
        return url
    }


    const recycleFetchAudio = async () => {

        for (let i = 0; i < readerAudioSrcArr.value.length; i++) {
            let blob = await fetchAudio(readerAudioSrcArr.value[i])
            let sound = initHowl(blob)
            if (i === 0) {
                sound.play()
            }
            if (i > 0 && howlerList.value.length === 0) {
                return
            } else {
                howlerList.value.push(sound)
            }
        }
    }


    // 初始化Howl
    const initHowl = (src) => {
        return new Howl({
            format: ['mp3'],
            src,
            onload: () => {
                howlerCanplay.value = true
            },
            onend: () => {
                curParagraphIndex.value++
                if (curParagraphIndex.value < howlerList.value.length) {
                    howlerList.value[curParagraphIndex.value].play()
                }
            },
            onstop: () => {

            },
        })
    }


    return {
        playerStatus,
        togglePlayerStatus,
        playerInit,
        howlerList,
    }
}